import { render } from "./ChatPreviewOverlay.vue?vue&type=template&id=71ab1090"
import script from "./ChatPreviewOverlay.vue?vue&type=script&lang=js"
export * from "./ChatPreviewOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__